<template>
  <v-card class="pa-6">
    <v-card-text>
      <p class="pa-3 mb-0">
        You have unsaved changes.
      </p>
    </v-card-text>

    <v-card-actions>
      <v-btn
        outlined
        color="coolgray"
        @click.stop="submitBookmarkForm('Saved')"
      >
        Save
      </v-btn>

      <v-btn
        outlined
        color="primary"
        @click.stop="cancelForm"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import BookmarkMixin from 'src/tools/store/utils/bookmarks-mixin'

export default {
  name: 'BookmarkCancel',
  mixins: [
    BookmarkMixin,
  ],
}
</script>
